export default "__VITE_ASSET__bkd8BFS8__"